import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import "./CityDashboard.scss";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  // Legend,
  ResponsiveContainer
} from "recharts";
import Cookies from "universal-cookie";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import Snackbar from "@material-ui/core/Snackbar";
// import Button from "@material-ui/core/Button/Button";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";

class CityDashboard extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    this.city_config = this.cookies.get("city_config");
    this.city_name = this.cookies.get("city_name");
    this.city_id = this.cookies.get("city_id");
    this.city_skey = this.cookies.get("city_skey");
    this.student_is_manager = this.cookies.get("student_is_manager");
    this.student_role = this.cookies.get("student_role");
    this.student_team_name = this.cookies.get("student_team_name");

    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;

    this.state = {};
  }

  render() {
    let dynamicPlotData;
    if (this.props.combinedPlotData1.length > 1) {
      dynamicPlotData = this.props.combinedPlotData1;
    } else {
      dynamicPlotData = this.props.selectedPlotData1;
    }
    let dynamicPlotData2;
    if (this.props.combinedPlotData2.length > 1) {
      dynamicPlotData2 = this.props.combinedPlotData2;
    } else {
      dynamicPlotData2 = this.props.selectedPlotData2;
    }

    const subPolicyData = this.props.cityPolicies.filter(
      item => item.name === this.props.citySubPolicy
    );
    let plotColor = "slategray";
    return (
      <div className={`${this.props.display === "show" ? "active" : "hidden"}`}>
        {/* <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.snackOpen}
          ContentProps={{
            "aria-describedby": "message-id"
          }}
          className={this.state.snackType}
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === "snack"
              ? [
                  <Button key="yes" color="secondary" onClick={this.logoutYes}>
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>
                ]
              : []
          }
        /> */}

        <div className="cityDashboardWrapper">
          <div className="dashboardFlex flex flex-30-70">
            <div className="cityDashboardMetricsWrapper">
              <div className="metricsFlex flex flex-50-50">
                {this.props.cityCurrent.map((item, index) => (
                  <div
                    key={index}
                    className="metricColor flex flex-justify-between"
                  >
                    <h3
                      style={
                        Object.keys(item)
                          .toString()
                          .includes("Costs")
                          ? { color: "red" }
                          : Object.keys(item)
                              .toString()
                              .includes("Revenue")
                          ? { color: "green" }
                          : null
                      }
                    >
                      {Object.keys(item)} :{" "}
                    </h3>
                    <h3
                      style={
                        Object.keys(item)
                          .toString()
                          .includes("Costs")
                          ? { color: "red" }
                          : Object.keys(item)
                              .toString()
                              .includes("Revenue")
                          ? { color: "green" }
                          : null
                      }
                    >
                      {item[Object.keys(item)][0].unit === "money"
                        ? `$${item[Object.keys(item)][0].City.toFixed(
                            2
                          ).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}`
                        : item[Object.keys(item)][0].unit === "percent"
                        ? `${item[Object.keys(item)][0].City.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          )}%`
                        : item[Object.keys(item)][0].unit === "number"
                        ? `${item[Object.keys(item)][0].City.toFixed(2).replace(
                            /(\d)(?=(\d{3})+(?!\d))/g,
                            "$1,"
                          )} ${
                            Object.keys(item)
                            .toString()
                            .includes("PM")
                            ? "µg/m³"
                            : Object.keys(item)
                            .toString()
                            .includes("CO2")
                            ? "T"
                            : ""
                        }`
              : item[Object.keys(item)][0].City}
                    </h3>
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-50-50">
              <div className="plotContainerDiv">
                <div className="dropdown">
                  <select
                    className="plotSelect"
                    name="selectedMetric1"
                    value={this.props.selectedMetric1}
                    onChange={e => this.props.onPlotChange1(e)}
                    id="selectedMetric1"
                  >
                    {this.props.selectionAvailable ? (
                      <Fragment>
                        <option>Please select Data for Review</option>
                        <optgroup label="---Metrics---">
                          {this.props.metricsSelections.map((item, index) => (
                            <option
                              key={index}
                              value={item}
                              name="selectedMetric1"
                            >
                              {item}
                            </option>
                          ))}
                        </optgroup>
                        <optgroup label="---Costs---">
                          {this.props.costSelections.map((item, index) => (
                            <option
                              key={index}
                              value={item}
                              name="selectedMetric1"
                            >
                              {item}
                            </option>
                          ))}
                        </optgroup>
                        <optgroup label="---Revenue---">
                          {this.props.revenueSelections.map((item, index) => (
                            <option
                              key={index}
                              value={item}
                              name="selectedMetric1"
                            >
                              {item}
                            </option>
                          ))}
                        </optgroup>
                      </Fragment>
                    ) : (
                      <option>Gathering Selections...</option>
                    )}
                  </select>
                </div>
                {this.props.plotType1 === "city" ||
                this.props.plotType1 === "citycost" ||
                this.props.plotType1 === "cityrevenue" ? (
                  <ResponsiveContainer width={"98%"} height="80%">
                    <LineChart
                      data={dynamicPlotData}
                      // data={this.state.selectedForecastPlotData1}
                      margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                    >
                      <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                      <XAxis stroke={plotColor} dataKey="year" />
                      <YAxis stroke={plotColor} />
                      <Tooltip
                        active={true}
                        formatter={value =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="City"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted City"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : null}
                {this.props.plotType1 === "district" ||
                this.props.plotType1 === "districtcost" ||
                this.props.plotType1 === "districtrevenue" ? (
                  <ResponsiveContainer width={"98%"} height="80%">
                    <LineChart
                      data={dynamicPlotData}
                      margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                    >
                      <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                      <XAxis stroke={plotColor} dataKey="year" />
                      <YAxis stroke={plotColor} />
                      <Tooltip
                        formatter={value =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="Corbusville"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Downtown"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="HowardGardens"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="JacobsHill"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="MosesGulch"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted Corbusville"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Downtown"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted HowardGardens"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted JacobsHill"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted MosesGulch"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : null}
                {this.props.plotType1 === "transportation" ? (
                  <ResponsiveContainer width={"98%"} height="80%">
                    <LineChart
                      data={dynamicPlotData}
                      margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                    >
                      <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                      <XAxis stroke={plotColor} dataKey="year" />
                      <YAxis stroke={plotColor} />
                      <Tooltip
                        formatter={value =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : null}
                <ReactCSSTransitionGroup
                  transitionName="fade"
                  transitionAppear={true}
                  transitionAppearTimeout={500}
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={300}
                >
                  {this.props.plotType1 ? (
                    <p>Please hover over plot for data.</p>
                  ) : null}
                </ReactCSSTransitionGroup>
              </div>
              <div className="plotContainerDiv">
                <div className="dropdown">
                  <select
                    className="plotSelect"
                    name="selectedMetric2"
                    value={this.props.selectedMetric2}
                    onChange={e => this.props.onPlotChange2(e)}
                    id="selectedMetric2"
                  >
                    {this.props.selectionAvailable ? (
                      <Fragment>
                        <option>Please select Data for Review</option>
                        <optgroup label="---Metrics---">
                          {this.props.metricsSelections.map((item, index) => (
                            <option
                              key={index}
                              value={item}
                              name="selectedMetric2"
                            >
                              {item}
                            </option>
                          ))}
                        </optgroup>
                        <optgroup label="---Costs---">
                          {this.props.costSelections.map((item, index) => (
                            <option
                              key={index}
                              value={item}
                              name="selectedMetric2"
                            >
                              {item}
                            </option>
                          ))}
                        </optgroup>
                        <optgroup label="---Revenue---">
                          {this.props.revenueSelections.map((item, index) => (
                            <option
                              key={index}
                              value={item}
                              name="selectedMetric2"
                            >
                              {item}
                            </option>
                          ))}
                        </optgroup>
                      </Fragment>
                    ) : (
                      <option>Gathering Selections...</option>
                    )}
                  </select>
                </div>
                {this.props.plotType2 === "city" ||
                this.props.plotType2 === "citycost" ||
                this.props.plotType2 === "cityrevenue" ? (
                  <ResponsiveContainer width={"98%"} height="80%">
                    <LineChart
                      data={dynamicPlotData2}
                      margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                    >
                      <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                      <XAxis stroke={plotColor} dataKey="year" />
                      <YAxis stroke={plotColor} />
                      <Tooltip
                        formatter={value =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="City"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted City"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : null}
                {this.props.plotType2 === "district" ||
                this.props.plotType2 === "districtcost" ||
                this.props.plotType2 === "districtrevenue" ? (
                  <ResponsiveContainer width={"98%"} height="80%">
                    <LineChart
                      data={dynamicPlotData2}
                      margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                    >
                      <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                      <XAxis stroke={plotColor} dataKey="year" />
                      <YAxis stroke={plotColor} />
                      <Tooltip
                        formatter={value =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="Corbusville"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Downtown"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="HowardGardens"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="JacobsHill"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="MosesGulch"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted Corbusville"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Downtown"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted HowardGardens"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted JacobsHill"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted MosesGulch"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                        strokeDasharray="10 5"
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : null}
                {this.props.plotType2 === "transportation" ? (
                  <ResponsiveContainer width={"98%"} height="80%">
                    <LineChart
                      data={dynamicPlotData2}
                      margin={{ top: 30, right: 10, left: 60, bottom: 5 }}
                    >
                      <CartesianGrid stroke={plotColor} strokeDasharray="3 3" />
                      <XAxis stroke={plotColor} dataKey="year" />
                      <YAxis stroke={plotColor} />
                      <Tooltip
                        formatter={value =>
                          new Intl.NumberFormat("en").format(value)
                        }
                      />
                      {/* <Legend /> */}
                      <Line
                        type="monotone"
                        dataKey="Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Walk"
                        stroke="#DF344A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Car"
                        stroke="#5399C9"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Rail"
                        stroke="#FF6302"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />

                      <Line
                        type="monotone"
                        dataKey="Forecasted Bus"
                        stroke="#FECE00"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                      <Line
                        type="monotone"
                        dataKey="Forecasted Bike"
                        stroke="#80B43A"
                        strokeWidth="5px"
                        strokeDasharray="10 5"
                        dot={false}
                      />
                    </LineChart>
                  </ResponsiveContainer>
                ) : null}
                <ReactCSSTransitionGroup
                  transitionName="fade"
                  transitionAppear={true}
                  transitionAppearTimeout={500}
                  transitionEnterTimeout={500}
                  transitionLeaveTimeout={300}
                >
                  {this.props.plotType2 ? (
                    <p>Please hover over plot for data.</p>
                  ) : null}
                </ReactCSSTransitionGroup>
              </div>
            </div>
          </div>
          <div className="flex flex-justify-end">
            {this.student_is_manager === "true" ? (
              <Fragment>
                <button
                  className="forecastSubmit"
                  onClick={e => this.props.onForecastSubmit(e)}
                  disabled={this.props.forecasting}
                >
                  {this.props.forecasting ? "Forecasting..." : "Forecast"} (
                  {this.props.remainingForecastAttempts})
                </button>
                <div className="tooltip">
                  <span className="tooltiptext">
                    {this.props.toolTipMessage
                      ? this.props.toolTipMessage
                      : "Please Submit when ready!"}
                  </span>
                  <button
                    className={
                      this.props.suspendButton === true ||
                      this.props.policySuspended
                        ? "citySubmitSuspended"
                        : "citySubmit"
                    }
                    onClick={e => this.props.citySubmitPrevent(e)}
                  >
                    {this.props.submitting === true
                      ? "Submitting..."
                      : [
                          this.props.suspendButton === true ||
                          this.props.policySuspended
                            ? "Suspended"
                            : "Submit"
                        ]}
                  </button>
                </div>
              </Fragment>
            ) : null}
          </div>
          <div className="polWrapper">
            <div className="subPolicySelection flex flex-30-70">
              <div>
                <div className="citySubPolicy">
                  {this.props.cityPolicies.map((item, index) => (
                    <div className="flex flex-auto" key={index}>
                      {this.props.citySubPolicy === item.name ? (
                        <span style={{ color: "#5399C9" }}>{"\u2B24"}</span>
                      ) : (
                        <span style={{ color: "rgba(255, 0, 0, 0)" }}>
                          {"\u2B24"}
                        </span>
                      )}
                      <h1
                        key={index}
                        citypol={item.name}
                        onClick={e => this.props.onCityPolicyClickHandler(e)}
                      >
                        {item.name}
                      </h1>
                    </div>
                  ))}
                </div>
                {/* If there are more than 9 policies, create pagination */}
                {/* {this.state.cityPolicies.length > 9 ? (
                <Pagination
                  onPageClick={this.onPageClick}
                  length={allSubPolicies.length}
                  className="pagination"
                />
              ) : null} */}
              </div>
              {/* --------COMPONENT--POLICY DESCRIPTION */}
              <div className="cityPolicyDescription">
                {/* <div className="flex flex-70-30"> */}
                <div>
                  {subPolicyData[0] ? (
                    subPolicyData[0].description.map((description, index) => (
                      <div key={index}>
                        {/* If zoning and zoning Mix is chosen, display the subpolicy data */}
                        {this.state.policyHeader === "Zoning" &&
                        this.state.subPolicy === "Zoning Mix" ? (
                          <h1 key={index}>{description}</h1>
                        ) : (
                          // Also if not, display the same thing???
                          <h1 key={index}>{description}</h1>
                        )}
                      </div>
                    ))
                  ) : (
                    //   Placeholder if no policy selected

                    <h1>Please Select a Policy</h1>
                  )}
                </div>
                <div className="flex flex-wrap">
                  {subPolicyData[0]
                    ? Object.values(subPolicyData[0].parameters).map(
                        (parameter, index) => ({
                          ...(parseInt(this.props.citySubPolicyDefaultValue) ===
                          index + 1 ? (
                            <button
                              className="defaultParameter"
                              onClick={e => this.props.onCitySelectHandler(e)}
                              value={index + 1}
                              key={index}
                              paranumber={index + 1}
                              polid={subPolicyData[0].polindex}
                              previousval={this.props.citySubPolicyPrevtValue}
                              year={this.props.currentYear}
                            >
                              {parameter.name}{" "}
                              {parseFloat(
                                this.props.citySubPolicyPrevtValue
                              ) === parseFloat(index + 1) ? (
                                <FontAwesomeIcon
                                  icon={["fas", "history"]}
                                  style={{ color: "#5399C9" }}
                                />
                              ) : null}
                            </button>
                          ) : this.state.policyHeader === "Zoning" &&
                            this.state.citySubPolicy === "Zoning Mix" ? (
                            <h1
                              className="zoneMixParams"
                              key={index}
                              paranumber={index + 1}
                              polid={subPolicyData[0].polindex}
                              year={this.props.currentYear}
                            >
                              {parameter.name}
                            </h1>
                          ) : (
                            <button
                              onClick={e => this.props.onCitySelectHandler(e)}
                              disabled={this.props.disabledButton}
                              className="selectParameter"
                              key={index}
                              paranumber={index + 1}
                              name={parameter.name}
                              value={index + 1}
                              polid={subPolicyData[0].polindex}
                              year={this.props.currentYear}
                              previousval={this.props.citySubPolicyPrevtValue}
                            >
                              {parameter.name}{" "}
                              {parseFloat(
                                this.props.citySubPolicyPrevtValue
                              ) === parseFloat(index + 1) ? (
                                <FontAwesomeIcon
                                  icon={["fas", "history"]}
                                  style={{ color: "#5399C9" }}
                                />
                              ) : null}
                            </button>
                          ))
                        })
                      )
                    : null}
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(CityDashboard);
